import React from 'react';

import { Checkbox as DefaultCheckbox } from '~shared/components/Checkbox';

interface CheckboxProps {
  indeterminate: boolean;
  checked: boolean;
  onChange: (
    state: React.FormEvent<HTMLInputElement>
  ) => React.FormEvent<HTMLInputElement>;
}
/**
 * The checkbox component for the table
 */
export const Checkbox = ({
  indeterminate,
  checked,
  onChange,
  ...props
}: CheckboxProps) => {
  // checkboxes need to be able to have indeterminate states based externally,
  // to do that we need to have backup refs

  // return the generic checkbox
  return (
    <DefaultCheckbox
      size={'medium'}
      checked={indeterminate ? 'mixed' : checked}
      onChange={onChange}
      {...props}
    />
  );
};
Checkbox.displayName = 'Checkbox';
